import { useState, useEffect, useContext, useMemo } from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

/* contexts */
import { Context } from '../../../context/UserContext';

import moment from 'moment';
import 'moment/locale/pt-br';

import { Stack, Button, Box, Tooltip, IconButton } from '@mui/material';
import {
    Delete,
    Edit,
    Print,
    AddShoppingCart,
    RemoveShoppingCart,
    ShoppingCart,
    ShoppingCartCheckout,
} from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';
import CustomDialog from '../../layout/CustomDialog';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import Input from '../../form/Input';
import Checkbox from '../../form/Checkbox';
import DataList from '../../form/DataList';
import Select from '../../form/Select';
import SelectEmpresa from '../../form/SelectEmpresa';
import TextArea from '../../form/TextArea';

import * as DataListAPI from '../../../api/dataList';

/* utils */
import { retornaDataHora, retornaData } from '../../../utils/retornaDataFormatada';
import { obterSituacaoAtualDoColaborador } from '../../../api/rh';

function Form({
    token,
    dados,
    setDados,
    handleSubmit,

    btnText,
    caminhoVoltar,
    OptionsEmpresa,
    enumParentesco,
    pessoaId,
    empresaId,
    empresaIds,
    empresaTabelaId,
}) {
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const { parametro } = useContext(Context);
    const isAdmin = localStorage.getItem('isAdmin') === 'true';
    const urlParams = new URLSearchParams(window.location.search);

    const params = new URLSearchParams({
        ul: urlParams.get('ul'),
        li: urlParams.get('li'),
        tipo: urlParams.get('tipo'),
        operacao: urlParams.get('operacao'),
        uuid: urlParams.get('uuid'),
        btnText: urlParams.get('btnText'),
    });

    //variável
    const tipo = urlParams.get('tipo');

    // Estado para rastrear a aba ativa
    const [abaAtiva, setAbaAtiva] = useState(0);
    const [gridAtiva, setGridAtiva] = useState('cabecalho');

    //abas
    const [tabEnabled, setTabEnabled] = useState({
        cabecalho: true,
        funcional: tipo === 'funcional' ? true : false,
        ferias: tipo === 'ferias' ? true : false,
        afastamento: tipo === 'afastamento' ? true : false,
        vacinacao: tipo === 'vacinacao' ? true : false,
        exame: tipo === 'exame' ? true : false,
        dependente: tipo === 'dependente' ? true : false,
        declaracao: tipo === 'declaracao' ? true : false,
        declaracaoTipos: tipo === 'declaracaoTipos' ? true : false,
        assinatura: true,
    });
    /* identifica a aba atual */
    const handleSelect = (index) => {
        setAbaAtiva(index);

        // Definir qual grid será atualizada com base na aba ativa
        switch (index) {
            case 0:
                setGridAtiva('cabecalho');
                break;
            case 1:
                setGridAtiva('funcional');
                break;
            case 2:
                setGridAtiva('ferias');
                break;
            case 3:
                setGridAtiva('afastamento');
                break;
            case 4:
                setGridAtiva('vacinacao');
                break;
            case 5:
                setGridAtiva('exame');
                break;
            case 6:
                setGridAtiva('dependente');
                break;
            case 7:
                setGridAtiva('declaracao');
                break;
            case 8:
                setGridAtiva('declaracaoTipos');
                break;
            default:
                setGridAtiva('cabecalho');
        }
    };

    const consultaDatalist = async ({ separador, empresaId, tabela, id, descricao, condicao, filtro, ativo, tipo }) => {
        if (separador === 'colaborador') {
            return await DataListAPI.dataListColaborador({ empresaId, filtro, ativo, tipo });
        }

        // para "parceiro", "centroCusto" ou qualquer outro valor
        return await DataListAPI.dataList({ empresaId, tabela, id, descricao, condicao, filtro });
    };

    //datalist
    const [Colaborador, setColaborador] = useState({});
    const [OptionsColaborador, setOptionsColaborador] = useState([]);
    const [Dependente, setDependente] = useState({});
    const [OptionsDependente, setOptionsDependente] = useState([]);
    const [Cargo, setCargo] = useState({});
    const [OptionsCargo, setOptionsCargo] = useState([]);
    const [Nivel, setNivel] = useState({});
    const [OptionsNivel, setOptionsNivel] = useState([]);
    const [Setor, setSetor] = useState({});
    const [OptionsSetor, setOptionsSetor] = useState([]);
    const [CID, setCID] = useState({});
    const [OptionsCID, setOptionsCID] = useState([]);
    const [Vacina, setVacina] = useState({});
    const [OptionsVacina, setOptionsVacina] = useState([]);
    const [exame, setExame] = useState({});
    const [optionsExame, setOptionsExame] = useState([]);
    const [rhDeclaracaoTipos, setRhDeclaracaoTipos] = useState({});
    const [OptionsDeclaracaoTipos, setOptionsDeclaracaoTipos] = useState([]);

    useEffect(() => {
        if (dados?.Pessoa) setColaborador(dados.Pessoa);
        if (dados?.Dependente) setDependente(dados.Dependente);
        if (dados?.rhCargo) setCargo(dados.rhCargo);
        if (dados?.rhNivel) setNivel(dados.rhNivel);
        if (dados?.Setor) setSetor(dados.Setor);
        if (dados?.rhVacina) setVacina(dados.rhVacina);
        if (dados?.rhCID) setCID(dados.rhCID);
        if (dados?.rhTabela27eSocial) setExame(dados.rhTabela27eSocial);
        if (dados?.rhDeclaracaoTipo) setRhDeclaracaoTipos(dados.rhDeclaracaoTipo);
    }, [
        dados?.Pessoa,
        dados?.Dependente,
        dados?.rhCargo,
        dados?.rhNivel,
        dados?.Setor,
        dados?.rhVacina,
        dados?.rhCID,
        dados?.rhTabela27eSocial,
        dados?.rhDeclaracaoTipo,
    ]);

    useEffect(() => {
        //atualiza o cargo e setor atual do colaborador
        const fetchData = async (pessoaId) => {
            try {
                if (!pessoaId) return;

                const result = await obterSituacaoAtualDoColaborador({ pessoaId });

                if (result) {
                    const { cargoId, nivelId, setorId } = result;
                    setDados((prev) => ({
                        ...prev,
                        cargoId,
                        nivelId,
                        setorId,
                    }));
                    setCargo(result?.rhCargo || {});
                    setNivel(result?.rhNivel || {});
                    setSetor(result?.Setor || {});
                }
            } catch (error) {
                console.error('Erro ao obter situação do colaborador:', error);
                // Opcional: notificar o usuário ou registrar erro
            }
        };

        if (dados.pessoaId && btnText.toLowerCase() === 'cadastrar') {
            fetchData(dados.pessoaId);
        }
    }, [dados.pessoaId, btnText]);

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;
        if (name.startsWith('Colaborador.')) {
            setColaborador({
                ...Colaborador,
                [name.split('.')[1]]: value,
            });
            //carrega o datalist
            const result = await consultaDatalist({
                separador: 'colaborador',
                empresaId: dados.empresaId,
                filtro: value,
            });

            setOptionsColaborador(result || []);

            const selected = (result || []).find((x) => String(x.descricao || '') === String(value));

            setDados((prev) => ({
                ...prev,
                pessoaId: selected?.id ?? null,
            }));
        } else if (name.startsWith('Cargo.')) {
            setCargo({
                ...Cargo,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                separador: 'cargo',
                empresaId: dados.empresaId,
                tabela: 'rhCargo',
                filtro: value,
            });

            setOptionsCargo(result);

            const selected = (result || []).find((x) => String(x.descricao || '') === String(value));

            setDados((prev) => ({
                ...prev,
                cargoId: selected?.id ?? null,
            }));
        } else if (name.startsWith('Nivel.')) {
            setNivel({
                ...Nivel,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                separador: 'nivel',
                empresaId: dados.empresaId,
                tabela: 'rhNivel',
                filtro: value,
            });

            setOptionsNivel(result);

            const selected = (result || []).find((x) => String(x.descricao || '') === String(value));

            setDados((prev) => ({
                ...prev,
                nivelId: selected?.id ?? null,
            }));
        } else if (name.startsWith('Setor.')) {
            setSetor({
                ...Setor,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                separador: 'setor',
                empresaId: dados.empresaId,
                tabela: 'Setor',
                filtro: value,
            });

            setOptionsSetor(result);

            const selected = (result || []).find((x) => String(x.descricao || '') === String(value));

            setDados((prev) => ({
                ...prev,
                setorId: selected?.id ?? null,
            }));
        } else if (name.startsWith('CID.')) {
            setCID({
                ...CID,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                separador: 'cid',
                empresaId: dados.empresaId,
                tabela: 'rhCID',
                descricao: 'descricaoAbreviada',
                filtro: value,
            });

            setOptionsCID(result);

            const selected = (result || []).find((x) => String(x.descricao || '') === String(value));

            setDados((prev) => ({
                ...prev,
                cidId: selected?.id ?? null,
            }));
        } else if (name.startsWith('Vacina.')) {
            setVacina({
                ...Vacina,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                separador: 'vacina',
                empresaId: dados.empresaId,
                tabela: 'rhVacina',
                filtro: value,
            });

            setOptionsVacina(result);

            const selected = (result || []).find((x) => String(x.descricao || '') === String(value));

            setDados((prev) => ({
                ...prev,
                vacinaId: selected?.id ?? null,
            }));
        } else if (name.startsWith('Exame.')) {
            setExame({
                ...exame,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                tabela: 'rhTabela27eSocial',
                filtro: value,
            });
            setOptionsExame(result);

            const selected = (result || []).find((x) => String(x.descricao || '') === String(value));

            setDados((prev) => ({
                ...prev,
                tb27eSocialId: selected?.id ?? null,
            }));
        } else if (name.startsWith('Dependente.')) {
            setDependente({
                ...Dependente,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                empresaId: dados.empresaId,
                tabela: 'Pessoa',
                filtro: value,
            });
            setOptionsDependente(result);

            const selected = (result || []).find((x) => String(x.descricao || '') === String(value));

            setDados((prev) => ({
                ...prev,
                dependentePessoaId: selected?.id ?? null,
            }));
        } else if (name.startsWith('rhDeclaracaoTipos.')) {
            setRhDeclaracaoTipos({
                ...rhDeclaracaoTipos,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                empresaId: empresaTabelaId,
                tabela: 'rhDeclaracaoTipo',
                filtro: value,
            });
            setOptionsDeclaracaoTipos(result);

            const selected = (result || []).find((x) => String(x.descricao || '') === String(value));

            setDados((prev) => ({
                ...prev,
                tipoDeclaracaoId: selected?.id ?? null,
            }));
        } else {
            setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
        }
    }
    async function handleOnBlur(e) {}
    function handleOnFocus(e) {}
    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    /* modo tema */
    const theme = tableThemeCustom();

    return (
        <div>
            <Tabs selectedIndex={abaAtiva} onSelect={handleSelect}>
                <form onSubmit={submit}>
                    <h1>Recursos Humanos</h1>
                    <TabList>
                        <Tab title={'Informações do Colaborador'}>Cabeçalho</Tab>
                        <Tab disabled={!tabEnabled.funcional} title={'Registros na Ficha Funcional'}>
                            Ficha Funcional
                        </Tab>
                        <Tab disabled={!tabEnabled.ferias} title={'Registros de férias do colaborador'}>
                            Férias
                        </Tab>
                        <Tab disabled={!tabEnabled.afastamento} title={'Registros de afastamentos do colaborador'}>
                            Afastamentos
                        </Tab>
                        <Tab disabled={!tabEnabled.vacinacao} title={'Registros de vacinas do colaborador'}>
                            Vacinação
                        </Tab>
                        <Tab disabled={!tabEnabled.exame} title={'Registros de exames do colaborador'}>
                            Exames
                        </Tab>
                        <Tab disabled={!tabEnabled.dependente} title={'Registros de dependentes do colaborador'}>
                            Dependentes
                        </Tab>
                        <Tab disabled={!tabEnabled.declaracao} title={'Registros de declarações do colaborador'}>
                            Declarações
                        </Tab>
                        {isAdmin && (
                            //permitido apenas a usuario com permissões de administrador
                            <Tab
                                disabled={!tabEnabled.declaracaoTipos}
                                title={'Registros de tipos de declarações utilizados no sistema'}
                            >
                                Tipos de Declarações
                            </Tab>
                        )}
                    </TabList>
                    {/* Cabeçalho do form */}
                    <TabPanel>
                        <div>
                            <SelectEmpresa
                                text="Selecione a Empresa"
                                name="empresaId"
                                options={OptionsEmpresa}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.empresaId || ''}
                                required
                                notOptNull={true}
                            />
                            <Input
                                text="Número"
                                type="text"
                                name="numero"
                                placeholder="Número"
                                inputWidth="100px"
                                title="Digite o código do setor"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.numero || ''}
                                readonly={true}
                            />
                            <Input
                                text="Data"
                                type="date"
                                name="data"
                                placeholder="Data"
                                title="Data do movimento"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.data && retornaData(dados.data)}
                            />
                            <DataList
                                text="Colaborador"
                                name="Colaborador.descricao"
                                placeholder={`Pesquise o colaborador`}
                                inputWidth="400px"
                                filteredOptions={OptionsColaborador}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={Colaborador?.descricao || ''}
                                required={true}
                            />
                            <Checkbox
                                title="Estagiário informa que a pessoa ainda não foi contratada"
                                text="Estagiário"
                                name="estagiario"
                                handleOnChange={handleChange}
                                value={dados.estagiario}
                                checked={!!dados.estagiario}
                            />
                            <Checkbox
                                title="Vigente informa que essa é situação atual do colaborador"
                                text="Vigente"
                                name="vigente"
                                handleOnChange={handleChange}
                                value={dados.vigente}
                                checked={!!dados.vigente}
                            />
                            <Checkbox
                                title="Ativa quando marcado"
                                text="Ativo"
                                name="ativo"
                                handleOnChange={handleChange}
                                value={dados.ativo}
                                checked={!!dados.ativo}
                            />
                        </div>
                        <div>
                            <TextArea
                                text="Observação"
                                type="text"
                                name="observacao"
                                placeholder="Digite aqui as observações"
                                title={`Digite as observações necessárias`}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.observacao || ''}
                                textAlign="left"
                                linhas="4"
                                colunas="130"
                            />
                        </div>
                    </TabPanel>
                    {/* Ficha Funcional */}
                    <TabPanel>
                        <div>
                            <Input
                                text="Admissão"
                                type="date"
                                name="admissao"
                                placeholder="Data"
                                title="Data de admissão do colaborador"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.admissao && retornaData(dados.admissao)}
                            />
                            <Input
                                text="Demissão"
                                type="date"
                                name="demissao"
                                placeholder="Data"
                                title="Data de demissão do colaborador"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.demissao && retornaData(dados.demissao)}
                            />
                            <DataList
                                text="Cargo"
                                name="Cargo.descricao"
                                placeholder={`Pesquise o cargo do colaborador`}
                                inputWidth="350px"
                                filteredOptions={OptionsCargo}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={Cargo?.descricao || ''}
                            />
                            <DataList
                                text="Nível"
                                name="Nivel.descricao"
                                placeholder={`Pesquise o nível do cargo do colaborador`}
                                inputWidth="200px"
                                filteredOptions={OptionsNivel}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={Nivel?.descricao || ''}
                            />
                            <DataList
                                text="Setor"
                                name="Setor.descricao"
                                placeholder={`Pesquise o setor de trabalho do colaborador`}
                                inputWidth="300px"
                                filteredOptions={OptionsSetor}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={Setor?.descricao || ''}
                            />
                        </div>
                    </TabPanel>
                    {/* Férias */}
                    <TabPanel>
                        <div>
                            <Input
                                text="Início"
                                type="date"
                                name="dataVigenciaInicio"
                                placeholder="Data"
                                title="Data de início das férias do colaborador"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dataVigenciaInicio && retornaData(dados.dataVigenciaInicio)}
                            />
                            <Input
                                text="Término"
                                type="date"
                                name="dataVigenciaFim"
                                placeholder="Data"
                                title="Data de término das férias do colaborador"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dataVigenciaFim && retornaData(dados.dataVigenciaFim)}
                            />
                            <Input
                                text="Exercício"
                                type="text"
                                name="exercicio"
                                placeholder="Ano"
                                inputWidth="100px"
                                title="Digite o nao referente as férias do colaborador"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.exercicio || ''}
                                required={true}
                            />
                            <Checkbox
                                title="Previsão de férias do colaborador"
                                text="Previsão"
                                name="provisao"
                                handleOnChange={handleChange}
                                value={dados.provisao}
                                checked={!!dados.provisao}
                            />
                        </div>
                    </TabPanel>
                    {/* Afastamento */}
                    <TabPanel>
                        <div>
                            <DataList
                                text="CID"
                                name="CID.descricao"
                                placeholder={`Pesquise o código CID aplicado ao afastamento`}
                                inputWidth="350px"
                                filteredOptions={OptionsCID}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={CID?.descricao || ''}
                            />
                            <Input
                                text="Início"
                                type="date"
                                name="dataVigenciaInicio"
                                placeholder="Data"
                                title="Data de início do afastamento do colaborador"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dataVigenciaInicio && retornaData(dados.dataVigenciaInicio)}
                            />
                            <Input
                                text="Término"
                                type="date"
                                name="dataVigenciaFim"
                                placeholder="Data"
                                title="Data de término do afastamento do colaborador"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dataVigenciaFim && retornaData(dados.dataVigenciaFim)}
                            />
                            <Checkbox
                                title="O motivo do afastamento foi causado por acidente de trabalho"
                                text="Acidente"
                                name="acidente"
                                handleOnChange={handleChange}
                                value={dados.acidente}
                                checked={!!dados.acidente}
                            />
                        </div>
                    </TabPanel>
                    {/* Vacinação */}
                    <TabPanel>
                        <div>
                            <DataList
                                text="Vacina"
                                name="Vacina.descricao"
                                placeholder={`Pesquise a vacina aplicada no colaborador`}
                                inputWidth="350px"
                                filteredOptions={OptionsVacina}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={Vacina?.descricao || ''}
                            />
                            <Input
                                text="Dose"
                                type="text"
                                name="dose"
                                placeholder="dose"
                                inputWidth="100px"
                                title="Descreva a dose da vacina"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dose || ''}
                            />
                            <Input
                                text="Aplicação"
                                type="date"
                                name="dataVigenciaInicio"
                                placeholder="Data"
                                title="Data de aplicação da vacina"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dataVigenciaInicio && retornaData(dados.dataVigenciaInicio)}
                            />
                            <Input
                                text="Validade"
                                type="date"
                                name="dataVigenciaFim"
                                placeholder="Data"
                                title="Data de validade da vacina"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dataVigenciaFim && retornaData(dados.dataVigenciaFim)}
                            />
                        </div>
                    </TabPanel>
                    {/* Exame */}
                    <TabPanel>
                        <div>
                            <DataList
                                text="Exame"
                                name="Exame.descricao"
                                placeholder={`Pesquise a lista de exames e diagnósticos disponíveis na tabela 27 do eSocial`}
                                inputWidth="400px"
                                filteredOptions={optionsExame}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={exame?.descricao || ''}
                            />
                            <Input
                                text="Data"
                                type="date"
                                name="dataVigenciaInicio"
                                placeholder="Data"
                                title="Data de aplicação da vacina"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dataVigenciaInicio && retornaData(dados.dataVigenciaInicio)}
                            />
                            <Input
                                text="Validade"
                                type="date"
                                name="dataVigenciaFim"
                                placeholder="Data"
                                title="Data de validade da vacina"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dataVigenciaFim && retornaData(dados.dataVigenciaFim)}
                            />
                            <Checkbox
                                title="marcar quando o exame for admissional"
                                text="Admissional"
                                name="exameAdmissao"
                                handleOnChange={handleChange}
                                value={dados.exameAdmissao}
                                checked={!!dados.exameAdmissao}
                            />
                            <Checkbox
                                title="marcar quando o exame for demissional"
                                text="Demissional"
                                name="exameDemissao"
                                handleOnChange={handleChange}
                                value={dados.exameDemissao}
                                checked={!!dados.exameDemissao}
                            />
                            <Checkbox
                                title="marcar quando o exame for periódico"
                                text="Periódico"
                                name="examePeriodico"
                                handleOnChange={handleChange}
                                value={dados.examePeriodico}
                                checked={!!dados.examePeriodico}
                            />
                        </div>
                    </TabPanel>
                    {/* Dependente */}
                    <TabPanel>
                        <div>
                            <DataList
                                text="Dependentes do Colaborador"
                                name="Dependente.descricao"
                                placeholder={`Pesquise o dependente do colaborador`}
                                inputWidth="400px"
                                filteredOptions={OptionsDependente}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={Dependente?.descricao || ''}
                            />
                            <Select
                                text="Grau de parentesco"
                                name="parentesco"
                                options={enumParentesco}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.parentesco || ''}
                                isEnum={true}
                                notOptNull={false}
                            />
                            <Input
                                text="Início"
                                type="date"
                                name="dataInicio"
                                placeholder="Data"
                                title="Data de início do vínculo de dependência com colaborador"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dataInicio && retornaData(dados.dataInicio)}
                            />
                            <Input
                                text="Final"
                                type="date"
                                name="dataFim"
                                placeholder="Data"
                                title="Data de fim do vínculo de dependência com colaborador"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.dataFim && retornaData(dados.dataFim)}
                            />
                            <Checkbox
                                title="Dependente vincula ao imposto de renda - IR"
                                text="Imposto de Renda-IR"
                                name="dependenteIR"
                                handleOnChange={handleChange}
                                value={dados.dependenteIR}
                                checked={!!dados.dependenteIR}
                            />
                            <Checkbox
                                title="Dependente vincula ao plano de saúde"
                                text="Plano Saúde"
                                name="dependentePlanoSaude"
                                handleOnChange={handleChange}
                                value={dados.dependentePlanoSaude}
                                checked={!!dados.dependentePlanoSaude}
                            />
                            <Checkbox
                                title="Dependente vincula ao salário família"
                                text="Salário Família"
                                name="dependenteSalarioFamilia"
                                handleOnChange={handleChange}
                                value={dados.dependenteSalarioFamilia}
                                checked={!!dados.dependenteSalarioFamilia}
                            />
                            <Checkbox
                                title="Ativa quando marcado"
                                text="Ativo"
                                name="ativo"
                                handleOnChange={handleChange}
                                value={dados.ativo}
                                checked={!!dados.ativo}
                            />
                        </div>
                    </TabPanel>
                    {/* Declaração */}
                    <TabPanel>
                        <div>
                            <div>
                                <DataList
                                    text="Tipo"
                                    name="rhDeclaracaoTipos.descricao"
                                    placeholder={`Tipos de declarações disponíveis no sistema`}
                                    inputWidth="400px"
                                    filteredOptions={OptionsDeclaracaoTipos}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={rhDeclaracaoTipos?.descricao || ''}
                                />
                                <Input
                                    text="Início"
                                    type="date"
                                    name="dataVigenciaInicio"
                                    placeholder="Data"
                                    title="Data de início da declaração"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.dataVigenciaInicio && retornaData(dados.dataVigenciaInicio)}
                                />
                                <Input
                                    text="Término"
                                    type="date"
                                    name="dataVigenciaFim"
                                    placeholder="Data"
                                    title="Data de validade da declaração"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.dataVigenciaFim && retornaData(dados.dataVigenciaFim)}
                                />
                            </div>
                        </div>
                    </TabPanel>
                    {/* Declaração tipos */}
                    <TabPanel>
                        <div>
                            <Input
                                text="Descrição"
                                type="text"
                                name="descricao"
                                placeholder="Descrição"
                                title="nome descritivo do tipo de declaração"
                                inputWidth="250px"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.descricao || ''}
                            />
                            <Input
                                text="Caminho"
                                type="text"
                                name="caminho"
                                placeholder="Caminho"
                                title="caminho do relatório onde será impresso a declaração"
                                inputWidth="250px"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.caminho || ''}
                            />
                            <Input
                                text="URL"
                                type="text"
                                name="url"
                                placeholder="URL"
                                title="url do relatório onde será impresso a declaração"
                                inputWidth="250px"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={dados.url || ''}
                            />
                            <Checkbox
                                title="Declaração exige vigência para ser emitida"
                                text="Exige Vigência"
                                name="exigeVigencia"
                                handleOnChange={handleChange}
                                value={dados.exigeVigencia}
                                checked={!!dados.exigeVigencia}
                            />
                            <Checkbox
                                title="Declaração exige arquivo anexo"
                                text="Exige Anexo"
                                name="exigeAnexo"
                                handleOnChange={handleChange}
                                value={dados.exigeAnexo}
                                checked={!!dados.exigeAnexo}
                            />
                            <Checkbox
                                title="Declaração exige assinatura do colaborador"
                                text="Exige Assinatura"
                                name="exigeAssinatura"
                                handleOnChange={handleChange}
                                value={dados.exigeAssinatura}
                                checked={!!dados.exigeAssinatura}
                            />
                            <Checkbox
                                title="Ativa quando marcado"
                                text="Ativo"
                                name="ativo"
                                handleOnChange={handleChange}
                                value={dados.ativo}
                                checked={!!dados.ativo}
                            />
                        </div>
                    </TabPanel>
                    <div>
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar, params)}>
                                Voltar
                            </Button>
                            <Button type="submit" variant="contained" color="success">
                                {btnText}
                            </Button>
                        </Stack>
                    </div>
                </form>
            </Tabs>
        </div>
    );
}
export default Form;
